module.exports = __webpack_public_path__ + "img/pluto137.4f6d605f.jpg";